export const workTypeOptions = [
  { value: 'general', label: 'General' },
  { value: 'irrigation', label: 'Irrigation' },
  { value: 'landPreparation', label: 'Land Preparation' },
  { value: 'planting', label: 'Planting' },
  { value: 'spraying', label: 'Spraying' },
  { value: 'spreading', label: 'Spreading' }
];
export const timingEventOptions = [
  { value: 'prePlant', label: 'Pre-Plant' },
  { value: 'planting', label: 'Planting' },
  { value: 'growing', label: 'Growing' },
  { value: 'harvest', label: 'Harvest' },
  { value: 'storage', label: 'Storage' },
  { value: 'annual', label: 'Annual' }
];

export const applicationMethodOptions = [
  { value: 'aerial', label: 'Aerial' },
  { value: 'airBlast', label: 'Air Blast' },
  { value: 'chemigation', label: 'Chemigation' },
  { value: 'fertigation', label: 'Fertigation' },
  { value: 'fumigation', label: 'Fumigation' },
  { value: 'ground', label: 'Ground' },
  { value: 'groundApplication', label: 'Ground Application' },
  { value: 'groundBanded', label: 'Ground - Banded' },
  { value: 'groundBroadcast', label: 'Ground - Broadcast' },
  { value: 'groundHooded', label: 'Ground - Hooded' },
  { value: 'groundInFurrow', label: 'Ground - In Furrow' },
  { value: 'groundIncorporated', label: 'Ground - Incorporated' },
  { value: 'groundSeedTreatment', label: 'Ground - Seed Treatment' },
  { value: 'groundSpot', label: 'Ground - Spot' },
  { value: 'groundVariableRate', label: 'Ground - Variable Rate' },
  { value: 'groundWipe', label: 'Ground - Wipe' },
  { value: 'planting', label: 'Planting' },
  { value: 'rePlanting', label: 'Re-Planting' },
  { value: 'sidedress', label: 'Sidedress' },
  { value: 'storage', label: 'Storage' },
  { value: 'topdress', label: 'Topdress' },
  { value: 'treeInjection', label: 'Tree Injection' },
  { value: 'waterRun', label: 'Water Run' }
];

export interface CarrierOption {
  id: string;
  name: string;
  type: string;
  standardUnit: string;
}

export const carrierOptions: CarrierOption[] = [
  {
    id: 'a1bc5512-3b57-4fc2-a5a9-e33786a55fb5',
    name: 'Water',
    type: 'Carrier - Spray',
    standardUnit: 'Gallon'
  },
  {
    id: '1c5c2842-4958-4700-9426-a5473cf32aa3',
    name: '10-34-0',
    type: 'Fert_Dist',
    standardUnit: 'Ton'
  },
  {
    id: '1e671d0f-a3f6-4d71-9408-c504aec16318',
    name: '28-0-0',
    type: 'Fert_Dist',
    standardUnit: 'Ton'
  },
  {
    id: 'cceeea7b-80a5-4c56-8db7-5b478d10c77e',
    name: '32-0-0',
    type: 'Fert_Dist',
    standardUnit: 'Ton'
  }
];
